import InputRange from 'react-input-range';

function SliderQuestion(props) {
  let inputfield = props.currency ?
    <div>
      <div className="mt-1 relative rounded-md shadow-sm">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <span className="text-gray-500 sm:text-sm">
            {props.currency === 'GBP' ? '£' : '$'}
          </span>
        </div>
        <input
          className="focus:ring-purple-500 focus:border-purple-500 block w-36 pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
          type="number"
          name={props.name}
          value={props.value}
          onChange={(event) => props.onChange(parseInt(event.target.value, 10) || props.min)}
          placeholder="0.00" />
        <div className="absolute inset-y-0 right-0 flex items-center">
          <label htmlFor="currency" className="sr-only">Currency</label>
          <select
            className="focus:ring-purple-500 focus:border-purple-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md"
            name={props.name}
            value={props.currency}
            onChange={(event) => props.onCurrencyChange(event.target.value || props.currency)} >
            <option value="USD">USD</option>
            <option value="GBP">GBP</option>
          </select>
        </div>
      </div>
    </div>
    :
    <div>
      <div className="mt-1 relative rounded-md shadow-sm">
        {/* <input type="text" name="price" id="price" className="focus:ring-purple-500 focus:border-purple-500 block w-36 pl-7 pr-12 sm:text-sm border-gray-300 rounded-md" placeholder="0.00" /> */}
        <input
          className="focus:ring-purple-500 focus:border-purple-500 block w-36 pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
          type="number"
          name={props.name}
          value={props.value}
          onChange={(event) => props.onChange(parseInt(event.target.value, 10) || props.min)} />
        <div className="absolute inset-y-0 right-0 flex items-center">
          <label htmlFor="currency" className="sr-only">{props.units}</label>
          <div className="focus:ring-purple-500 focus:border-purple-500 py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md">
            {props.units}
          </div>
        </div>
      </div>
    </div>

  return (
    <div className="pb-8 sm:pb-10">
      <div className="flex flex-row justify-between items-center">
        <div className="flex-1 pr-2 md:pr-4 text-sm">
          {props.prompt}
        </div>

        {inputfield}
      </div>

      <div className="my-4 sm:my-6">
        <InputRange
          maxValue={props.max}
          minValue={props.min}
          value={props.value}
          onChange={value => props.onChange(value)} />
      </div>
    </div>
  );
}

export default SliderQuestion;
